export const setBudgets = ( state, budgets ) => {
    state.budgets = budgets
}

export const setTeachers = ( state, teachers ) => {
    state.teachers = teachers
}

export const setProjects = ( state, projects ) => {
    state.projects = projects
}